import { createReactContext } from "#utils/reactContext";
import { type ConsolidatedPaymentPrefContextType } from "./types";

const [useConsolidatedPaymentPrefContext, ConsolidatedPaymentPrefContextProvider] =
  createReactContext<ConsolidatedPaymentPrefContextType>();

export { useConsolidatedPaymentPrefContext, ConsolidatedPaymentPrefContextProvider };
